import React, { useState } from 'react';
import queryString from 'query-string';
import LeftContent from './Children/leftContent';
import OtpSection from './Children/otpSection';
import './index.scss';
import VerifiedCard from './Children/verifiedCard';
import UpdatePassword from './Children/updatePassword';

const OTPPage = () => {
   const [showsuccess, setShowSuccess] = useState(1);
   const parsed = queryString.parse(window.location.search);
   const [verifyData, setVerifyData] = useState({is_terms_agreed: false, is_privacy_agreed: false, email_otp:parsed?.otp || ''});

   const renderRightPage = () => {
      if(showsuccess === 1){
         return <div className="right_wrap">
            <OtpSection 
            setShowSuccess={setShowSuccess}
            setVerifyData={setVerifyData}
            verifyData={verifyData} />
          </div>
      } else if(showsuccess === 2){
         return <div className="right_wrap"><UpdatePassword setShowSuccess={setShowSuccess} verificationData={verifyData} /></div>
      } else {
         return <div className="right_wrap"><VerifiedCard /></div>
      }
   }

 return <div className="public_content">
    <div className="left_wrap"><LeftContent /></div>
    {renderRightPage()}
 </div>    
};
export default OTPPage;